module.exports = __webpack_public_path__ + "img/bg_left.8c7dedaa.png";